export default "__VITE_ASSET__fOYMk2Th__"